"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProgressBar = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var theme_get_1 = require("@styled-system/theme-get");
var Box_1 = require("../Box");
var Container = (0, styled_components_1.default)(Box_1.Box)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  overflow: hidden;\n  ", ";\n"], ["\n  overflow: hidden;\n  ", ";\n"])), function (_a) {
    var progress = _a.progress;
    return progress >= 100 && "opacity: 0.5";
});
var Bar = (0, styled_components_1.default)(Box_1.Box)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: 100%;\n  height: 100%;\n  min-height: ", ";\n  transform: translateX(-", "%);\n  transition: transform 250ms;\n  ", ";\n"], ["\n  width: 100%;\n  height: 100%;\n  min-height: ", ";\n  transform: translateX(-", "%);\n  transition: transform 250ms;\n  ", ";\n"])), (0, theme_get_1.themeGet)("space.2"), function (_a) {
    var progress = _a.progress;
    return 100 - progress;
}, function (_a) {
    var progress = _a.progress;
    return progress >= 100 && "opacity: 0.75";
});
var ProgressBar = function (_a) {
    var color = _a.color, progress = _a.progress, rest = __rest(_a, ["color", "progress"]);
    return (react_1.default.createElement(Container, __assign({ borderLeft: "1px solid ".concat(color), position: "relative", progress: progress }, rest),
        react_1.default.createElement(Bar, { progress: progress, backgroundColor: color })));
};
exports.ProgressBar = ProgressBar;
exports.ProgressBar.displayName = "ProgressBar";
exports.ProgressBar.defaultProps = {
    color: "secondary",
};
var templateObject_1, templateObject_2;
//# sourceMappingURL=ProgressBar.js.map